import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/CharacterDetail/Hero/_components/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Library"] */ "/vercel/path0/app/_components/CharacterDetail/Hero/library.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/CharacterDetail/IPInfo/_components/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentViewedCharacters"] */ "/vercel/path0/app/_components/CharacterDetail/RecentViews/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/china.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/ContactButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/etc.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/eu.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/japanese.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/korean.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/vercel/path0/app/_components/Shared/Avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientGate"] */ "/vercel/path0/app/_components/Shared/ClientGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LikeButton"] */ "/vercel/path0/app/_components/Shared/LikeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/usa.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(public)/characters/_components/CharacterDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecordRecentCharacterView"] */ "/vercel/path0/libraries/recent-view/index.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
